const baseUrl = 'https://calcal.uk/';

export default class CalCalWPApi {
	static async get(url: string, authEmail: ?string = '', authToken: ?string = '') {
		let response = await fetch(baseUrl + url, {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			}
		});

		return response.json();
	}

	static async post(url, body = '', authEmail = '', authToken = '') {
		//console.log(body);
		let headers = {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		};
		let response;
		try {
			response = await fetch(baseUrl + url, {
				method: 'post',
				headers,
				body: JSON.stringify(body)
			});
		} catch (error) {
			console.log(error);
			return { error, error_description: 'Network request failed' };
		}

		// It's possible that the server sends us back something
		// that isn't json here, so just ignore it if we can't
		// parse it
		let result;
		//console.log('response', response);
		try {
			result = await response.json();
		} catch (e) {
			console.log('no json', response.text());
			result = { error: e };
		}
		if (__DEV__) console.log('posted', baseUrl + url, headers, JSON.stringify(body), result, response);
		return result;
	}

	/*static async postForm(url, body = '') {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };

    let response = await fetch(baseUrl + url, {
      method: 'post',
      headers,
      body: this.serializeJSON(body)
    });


    let result;

    try {
      result = await response.json();
    } catch(e) {
      console.log('no json');
      result = {error: e};
    }
	console.log('posted', baseUrl + url, headers, this.serializeJSON(body), result, response);
    return result;
  }

  static serializeJSON(data) {
	  return Object.keys(data).map(function (keyName) {
		return encodeURIComponent(keyName) + '=' + encodeURIComponent(data[keyName])
	  }).join('&');
	}*/

	static async put(url: string, body: RequestBody) {
		let response = await fetch(baseUrl + url, {
			method: 'put',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		});

		return response.json();
	}

	static async delete(url: string) {
		let response = await fetch(baseUrl + url, { method: 'delete' });
		let result = await response.json();

		return result;
	}
}
